import { axiosGet, axiosPost } from "../../react_axios/Axios";
import {
  SERVICE_ADD_ACTION_TYPE,
  SERVICE_DELETE_ACTION_TYPE,
  SERVICE_DETAIL_ACTION_TYPE,
  SERVICE_LIST_ACTION_TYPE,
  headers,
  serviceAddUrl,
  serviceDeleteUrl,
  serviceDetailUrl,
  serviceListUrl,
} from "../../utils/constants";

export const service_list_action =
  ( Name, Code, Status) =>
  async (dispatch) => {
    try {
      const mapdata = {
        userId:sessionStorage.getItem("userId") == "" ||
        sessionStorage.getItem("userId") == null
          ? ""
          : sessionStorage.getItem("userId"),
        Name: Name.toString().trim(),
        Code: Code.toString().trim(),
        Status: Status==1?1:Status==0?0:null,
      };
      const params = {
        userId: mapdata.userId === "" ? null : mapdata.userId,
        Name: mapdata.Name === "" ? "" : mapdata.Name,
        Code: mapdata.Code === "" ? "" : mapdata.Code,
        Status: mapdata.Status,
      };
      console.log("Services mapdata...", mapdata);
      const res = await axiosGet(serviceListUrl, params,headers);
      console.log("Services", res);
      dispatch({
        type: SERVICE_LIST_ACTION_TYPE,
        payload: res,
      });
      return res; // No need to wrap in Promise.resolve()
    } catch (err) {
      return Promise.reject(err);
    }
  };

export const service_detail_action =
  ( AdditionalServicesID) => async (dispatch) => {
    try {
      const params = {
        userId:sessionStorage.getItem("userId") == "" ||
        sessionStorage.getItem("userId") == null
          ? ""
          : sessionStorage.getItem("userId"),
        AdditionalServicesID: AdditionalServicesID,
      };
      console.log("Services detail mapdata...", params);
      const res = await axiosGet(serviceDetailUrl, params,headers);
      console.log("detailsServices", res);
      dispatch({
        type: SERVICE_DETAIL_ACTION_TYPE,
        payload: res,
      });
      return res; // No need to wrap in Promise.resolve()
    } catch (err) {
      return Promise.reject(err);
    }
  };

export const service_add_action =
  (
    AdditionalServicesID,
    Code,
    Name,
    PricingOn,
    HSNCode,
    GST,
    ServiceAccount,
    Description,StatusID
  ) =>
  async (dispatch) => {
    console.log(StatusID)
    try {
      const mapdata = {
        userId:sessionStorage.getItem("userId") == "" ||
        sessionStorage.getItem("userId") == null
          ? ""
          : sessionStorage.getItem("userId"),
        AdditionalServicesID: AdditionalServicesID
          ? AdditionalServicesID
          : "",
        Code: Code.toString().trim(),
        Name: Name.toString().trim(),
        PricingOn: PricingOn.toString().trim(),
        HSNCode: HSNCode.toString().trim(),
        GST: GST.toString().trim(),
        ServiceAccount: ServiceAccount.toString().trim(),
        Description: Description.toString().trim(),
        StatusID: StatusID?StatusID:0,
      };
      console.log("Services add mapdata...", mapdata);

      const res = await axiosPost(serviceAddUrl, mapdata, headers);
      dispatch({
        type: SERVICE_ADD_ACTION_TYPE,
        payload: res,
      });
      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  };

export const service_delete_action =
  ( AdditionalServicesID) => async (dispatch) => {
    try {
      const mapdata = {
        userId:sessionStorage.getItem("userId") == "" ||
        sessionStorage.getItem("userId") == null
          ? ""
          : sessionStorage.getItem("userId"),
        AdditionalServicesID: AdditionalServicesID
          ? AdditionalServicesID.toString().trim()
          : "",
      };

      const res = await axiosGet(serviceDeleteUrl, mapdata,headers);
      dispatch({
        type: SERVICE_DELETE_ACTION_TYPE,
        payload: res,
      });
      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  };
